<template>
  <VideoComponent
    v-if="item?.video"
    :item="item.video"
    :details-link="detailsLink"
    :show-ai-label="false"
    class="recvideo"
    remove-add-button
    hover-animation
    show-pending-tag
    :navigate-to-details-override="navigateToPendingAiDetails"
  />
</template>

<script setup lang="ts">
import VideoComponent from '@/components/base/VideoComponent.vue'
import { VideoEditVideoSettingsScreen } from '@/interfaces'
import { useSelectedAiVideo } from '@/composables/useSelectedAiVideo'
import type { AiProposal } from '@/services/ai-generated/types'
import { useRouter } from 'vue-router'

const props = defineProps<{
  columns?: unknown
  item?: AiProposal
  detailsLink?: string
}>()

const router = useRouter()
const { setAiVideoPrefetch } = useSelectedAiVideo()

function navigateToPendingAiDetails(): void {
  const video = props.item?.video
  const id = video?.video_id
  const link = props.detailsLink
  if (!id || !link || !props.item) return
  setAiVideoPrefetch(props.item)
  router.push({
    name: link,
    params: { id },
    query: { tab: VideoEditVideoSettingsScreen.EditVideo, proposal_id: props.item.proposal_id }
  })
}
</script>
